import React from 'react';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import SaveHouseholdDetails from 'Components/AdvisorApp/Viewport/ClientExperienceSaves/SaveHouseholdDetails';
import { useSaveDispatchContext, useSaveStateContext } from './ClientExperienceSavesContext';
import EscalatedClients from './EscalatedClients';
import OrphanedEmails from './OrphanedEmails';
import SaveFilters from './SaveFilters';

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    alignContent: 'stretch',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  rightSidebar: {
    width: theme.spacing(55),
    display: 'flex',
    alignItems: 'stretch',
  },
});

function ClientExperienceSavesPage({ classes, ...rest }) {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Client Experience Saves',
    isPageView: true,
  });

  const { escalatedHouseholdCollection, selectedEscalatedHousehold } = useSaveStateContext();
  const dispatch = useSaveDispatchContext();

  return (
    <div className={classNames(classes.root)} {...rootNodeProps} {...rest}>
      <SaveFilters
        collection={escalatedHouseholdCollection}
        dispatch={dispatch}
      />
      <div className={classes.content}>
        <div>
          <EscalatedClients
            test="client-experience-saves-escalated-clients"
            collection={escalatedHouseholdCollection}
            dispatch={dispatch}
          />
        </div>
        <div>
          <OrphanedEmails />
        </div>
      </div>
      <SaveHouseholdDetails
        className={classes.rightSidebar}
        selectedEscalatedHousehold={selectedEscalatedHousehold}
      />
    </div>
  );
}

export default withStyles(styles)(ClientExperienceSavesPage);
